import getExternalNoRanges from './getExternalNoRanges';
import watchDeleteRange from './deleteRange';
import watchDeleteConnectRange from './deleteConnectRange';

const watchExternalNoRanges = [
  getExternalNoRanges,
  watchDeleteRange,
  watchDeleteConnectRange
];

export default watchExternalNoRanges;
